<template>
  <div class="BoardView">
    <Wrap class="noPad" :class="wrap">
      <div v-if="title" class="BoardView-title">
        <Row>
          <Column :sm="hasButton ? 8 : 12" :xs="hasButton ? 6 : 12">
            <h2>
              {{ title }}
            </h2>
            <div>
              {{ sub }}
            </div>
          </Column>
          <Column v-if="hasButton" :sm="4" :xs="6">
            <slot name="button" />
          </Column>
        </Row>
        <TableSearch
          v-if="pagination"
          :pagination="pagination"
          @update:search="setSearch"
          @update:sortIndex="setSort" />
      </div>
      <div>
        <slot v-if="isLoaded" />
        <Empty v-else>
          <Loader class="lg info" />
          {{ $t('loading') }}
        </Empty>
      </div>
      <TableNav
        v-if="pagination"
        :pagination="pagination"
        :total="total" />
    </Wrap>
  </div>
</template>

<script>
import PaginationAccess from '@mixins/PaginationAccess'
import TableNav from '@components/board/TableNav'
import TableSearch from '@components/board/TableSearch'
import { getters } from '@utils'

export default {
  mixins: [PaginationAccess],
  components: {
    TableNav,
    TableSearch,
  },
  props: {
    title: String,
    sub: String,
    total: Number,
    wrap: {
      default: 'na',
      type: String,
    },
  },
  computed: {
    hasButton() {
      return this.$slots.button
    },
    ...getters(),
  },
}
</script>

<style lang="scss">
.BoardView {
  margin-bottom: $grid-unit;

  .BoardView-title {
    background: $white-bis;
    padding: $grid-unit;
    @include md {
      .Btn span.add {
        display: inline-block;
      }
    }

    h2 {
      @include ellipsis;
      font-size: $h2;
      margin-bottom: $grid-unit;
      text-transform: none;
    }

    .Btn span.add {
      display: none;
    }
  }

  > .FormSect {
    box-shadow: $shadow-md;
    padding: 0.5rem 0;
  }

  h3, h4 {
    color: $text-color-mid;
  }
}
</style>

<i18n>
{
  "en": {
    "loading": "Loading"
  }
}
</i18n>
